var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectbookTag03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_collectbook_tag_03",
    clipPath: "url(#clip0_2496_32273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36328 0.727273C4.34667 0.727273 1.09055 3.98338 1.09055 8C1.09055 12.0166 4.34667 15.2727 8.36328 15.2727H34.5451C38.5617 15.2727 41.8178 12.0166 41.8178 8C41.8178 3.98338 38.5617 0.727273 34.5451 0.727273H8.36328ZM0.363281 8C0.363281 3.58172 3.945 0 8.36328 0H34.5451C38.9634 0 42.5451 3.58172 42.5451 8C42.5451 12.4183 38.9634 16 34.5451 16H8.36328C3.945 16 0.363281 12.4183 0.363281 8Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1602 11.636V4.43555H18.913C20.4706 4.43555 21.2406 5.23012 21.2406 6.30598C21.2406 7.17789 20.6886 7.67011 19.9853 7.83536V7.90567C20.7519 7.94785 21.5218 8.58422 21.5218 9.67412C21.5218 10.7957 20.7167 11.636 19.0678 11.636H16.1602ZM17.4505 10.5531H18.8639C19.8131 10.5531 20.2103 10.1488 20.2103 9.57568C20.2103 8.92877 19.7042 8.43655 18.9026 8.43655H17.4505V10.5531ZM17.4505 7.50135H18.7513C19.4335 7.50135 19.9503 7.10406 19.9503 6.46769C19.9503 5.9122 19.5494 5.50788 18.7795 5.50788H17.4505V7.50135ZM22.5834 11.636V4.43555H23.8738V10.546H27.0521V11.636H22.5834Z",
    fill: "#938F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_32273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1818,
    height: 16,
    fill: "white",
    transform: "translate(0.363281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectbookTag03);
export default __webpack_public_path__ + "static/media/icon_collectbook_tag_03.eb84531e19c18f582400b39339027236.svg";
export { ForwardRef as ReactComponent };